import React, {useState, useEffect} from 'react';
import {Button, Form} from 'react-bootstrap';
import {useContextSelector} from 'use-context-selector';
import {useBreakpoint} from '../../util/handleBreakpoints';
import {LocalContext} from '../../context/LocalContext';
import checkOtherFiltersValid from '../../util/checkOtherFiltersValid';
import {useTranslation} from 'react-i18next';

const Filter = (props) => {
    const {t} = useTranslation();
    const breakpoints = useBreakpoint();
    const clientOnline = useContextSelector(LocalContext, v => v[0].clientOnline);
    const [filterValueInitialDiffer, setFiltersInitialDiffer] = useState(false)

    useEffect(() => {
        let fieldInitialValueDiffer = false;
        switch (props.filter.type) {
            case 'multi-select':
                switch (props.filter.config.variant) {
                    case 'list':
                    case 'dropdown':
                        fieldInitialValueDiffer = fieldInitialValueDiffer ||
                            props.filter.value.toString() !== props.filtersInitial.filters[props.filter.name].value.toString();
                        break
                    default:
                        break
                }
                break
            case 'single-select':
                switch (props.filter.config.variant) {
                    case 'list':
                    case 'dropdown':
                        fieldInitialValueDiffer = fieldInitialValueDiffer ||
                            props.filter.value !== props.filtersInitial.filters[props.filter.name].value;
                        break
                    default:
                        break
                }
                break
            case 'range': {
                fieldInitialValueDiffer = fieldInitialValueDiffer ||
                    props.filter.value.lower !== props.filtersInitial.filters[props.filter.name].value.lower;
                fieldInitialValueDiffer = fieldInitialValueDiffer ||
                    props.filter.value.upper !== props.filtersInitial.filters[props.filter.name].value.upper;
                break
            }
            case 'order': {
                fieldInitialValueDiffer = fieldInitialValueDiffer ||
                    props.filter.value.value !== props.filtersInitial.filters[props.filter.name].value.value;
                fieldInitialValueDiffer = fieldInitialValueDiffer ||
                    props.filter.value.ascending !== props.filtersInitial.filters[props.filter.name].value.ascending;
                break
            }
            default:
                break
        }

        if (!filterValueInitialDiffer && fieldInitialValueDiffer) {
            setFiltersInitialDiffer(true);
        }

        if (filterValueInitialDiffer && !fieldInitialValueDiffer) {
            setFiltersInitialDiffer(false);
        }
    }, [props.filter, props.filtersInitial, filterValueInitialDiffer])

    return <div
        key={props.filter.name}
        style={
            {
                background: 'white',
                paddingBottom: '0.75rem',
                ...(breakpoints.md ?
                    {
                        marginLeft: '1.5rem',
                        marginRight: '1.5rem',
                        paddingTop: '0.5rem',
                        paddingBottom: '1rem',
                        border: `3px solid rgba(0,0,0,0.08)`,
                        // boxShadow: filterValueInitialDiffer ? "0 0 0 .2rem rgba(0,123,255,.25)" : 'none',
                        marginBottom: '0.75rem',
                        borderRadius: '1.5rem',
                    } : {})
            }
        }
    >
        <div className="mb-0"
            style={
                {
                    // borderTop: breakpoints.md ? 'none' : `1px solid rgba(0,0,0,0.05)`,
                    display: 'flex',
                    alignItems: 'center',
                    padding: `${breakpoints.md ? "0.5rem" : "0"} 2rem 0.5rem 2rem`
                }
            }
        >
            <label
                htmlFor={`filter-${props.filter.name}`}
                style={
                    {
                        minHeight: '32px',
                        display: 'flex',
                        margin: 0,
                        alignItems: 'flex-end',
                    }
                }

            >
                <h6
                    className="mb-0"
                    style={
                        {
                            color: props.loading ? "var(--secondary)" : (filterValueInitialDiffer ? "var(--primary)" : "var(--dark)"),
                            fontSize: '1.1rem',
                            // fontFamily: 'Roboto',
                            fontWeight: 400
                        }
                    }
                >
                    {props.filter.label()}
                </h6>
            </label>
            {filterValueInitialDiffer ?
                <Button
                    id={`toggle-${props.filter.name}`}
                    className="ml-auto"
                    size="sm"
                    variant="outline-primary"
                    disabled={!clientOnline || props.loading}
                    style={
                        {
                            display: 'flex',
                            marginBottom: '-8px',
                            flexShrink: 0,
                            flexGrow: 0
                        }
                    }
                    onClick={
                        () => {
                            const othersValid = checkOtherFiltersValid(props.filter, props.filters);

                            props.setFilters({
                                ...props.filters,
                                changed: true,
                                valid: othersValid,
                                filters: {
                                    ...props.filters.filters,
                                    [props.filter.name]: {
                                        ...props.filtersInitial.filters[props.filter.name]
                                    }
                                }
                            })
                        }
                    }
                >
                    <span>{t('Providers.filters.reset')}</span>
                </Button> : null}
        </div>
        <div className={`${props.noPadding ? 'p-0' : null}`}
            style={
                {
                    padding: "0rem 2rem 0rem 2rem"
                }
            }
        >
            <Form.Group
                className="mb-0"
            >
                {props.children}
            </Form.Group>
        </div>
    </div>
}

export default Filter;
